import moment from 'moment';
import React, { ReactElement } from 'react';

import { INotaryAppointments } from '../types';
import AppointmentRow from './AppointmentRow';

const AppointmentsOnSameDay: React.FC<{ notaryAppointment?: INotaryAppointments }> = ({ notaryAppointment }) => {
  if (!notaryAppointment) return null;
  const { date } = notaryAppointment;
  const dateOfNewAppointment = moment(date || 0);
  const appointments = notaryAppointment?.currentAppointments;
  let NewAppointment: ReactElement;
  return (
    <div className='appointment-container appointment-same-day-container'>
      <div className='appointment-schedule-title'>Current Schedule - {dateOfNewAppointment.format('MM/DD/YYYY')}</div>
      <div className='appointment-schedule-list'>
        {appointments.length ? (
          appointments.map((appointment, index) => {
            const timeOfCurrentAppointment = moment(appointment.date);
            const isLastAppointment = index === appointments.length - 1;
            let shoudInsertNewAppointment = false;
            if (timeOfCurrentAppointment.isAfter(dateOfNewAppointment) && !NewAppointment) {
              NewAppointment = <AppointmentRow appointment={notaryAppointment} isNew />;
              shoudInsertNewAppointment = true;
            }
            return (
              <React.Fragment key={appointment.id}>
                {shoudInsertNewAppointment && NewAppointment}
                <AppointmentRow appointment={appointment} />
                {isLastAppointment && !NewAppointment && <AppointmentRow appointment={notaryAppointment} isNew />}
              </React.Fragment>
            );
          })
        ) : (
          <AppointmentRow appointment={notaryAppointment} />
        )}
      </div>
    </div>
  );
};

export default AppointmentsOnSameDay;
